import { OrganizationRole } from "./organization-role";
import { Organization } from "./organization";

interface OrganizationMembershipData {
  id?: number;
  userId?: number;
  organizationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  organizationRoles?: OrganizationRole[];
  organization?: Organization;
}


export class OrganizationMembership {
  public static getNonTranslatableFields(): string[] { return ['id', 'userId', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'userId', 'organizationId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  userId?: number;
  organizationId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  organizationRoles: OrganizationRole[];
  organization?: Organization;

  public static fromAPI(data: OrganizationMembershipData): OrganizationMembership {
    if(data.organizationRoles) {
      data.organizationRoles = OrganizationRole.fromAPIList(data.organizationRoles, []); // TODO : ADD TRANSLATIONS
    }
    if(data.organization) {
      data.organization = Organization.fromAPI(data.organization);
    }
    return new OrganizationMembership(data);
  }

  public static fromAPIList(data: OrganizationMembershipData[]): OrganizationMembership[] {
    return data.map((item: OrganizationMembershipData) => OrganizationMembership.fromAPI(item));
  }

  constructor({id, userId, organizationId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, organizationRoles = [], organization} : OrganizationMembershipData) {
    this.id = id;
    this.userId = userId;
    this.organizationId = organizationId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.organizationRoles = organizationRoles;
    this.organization = organization;
  }

  public toJson(): Object {
    return {
      id: this.id,
      userId: this.userId,
      organizationId: this.organizationId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
